module.exports = __webpack_public_path__ + "img/australia-diabetes-mellitus-female.c79d93ab.png";